/**
 * The main api service
 */
import http from '@util/http';
import { incubator } from '@api/req';
import moment from 'moment';

export async function querySaveAimsConfig(params) {
  return http.post(incubator.AIMS_CONFIG, params);
}

export async function queryFinanceIncome(params) {
  return http.get(incubator.FINANCE_INCOME, params);
}

export async function queryFinanceExpendure(params) {
  return http.get(incubator.FINANCE_EXPENDITURE, params);
}

export async function queryFinanceInvestment(params) {
  return http.get(incubator.FINANCE_INVESTMENT, params);
}

export async function queryFinanceByType(params) {
  return http.get(incubator.FINANCE_BY_TYPE, params);
}

export async function queryFinanceByMonth(params) {
  return http.get(incubator.FINANCE_BY_MONTH, params);
}

export async function queryFinanceRecord(params) {
  return http.get(incubator.FINANCE_RECORD, params);
}

export async function queryFinanceBudgetByType(params) {
  return http.get(incubator.FINANCE_BUDGET_BY_TYPE, params);
}

export async function queryFinanceBudgetByMonth(params) {
  return http.get(incubator.FINANCE_BUDGET_BY_MONTH, params);
}

export async function queryFinanceBudgetRecord(params) {
  return http.get(incubator.FINANCE_BUDGET_RECORD, params);
}

export async function queryUnbusinessByType(params) {
  return http.get(incubator.BUBESINESS_BY_TYPE, params);
}

export async function queryUnbusinessRecord(params) {
  return http.get(incubator.BUBESINESS_RECORD, params);
}

export async function queryProfitChartData(params) {
  return http.get(incubator.PROFIT_CHART, params);
}

export async function queryProfitDetail(params) {
  return http.get(incubator.PROFIT_RECORD, params);
}

export async function queryRelateTodo(params) {
  return http.get(incubator.RELATE_TODO, params);
}

export async function queryRelateDone(params) {
  return http.get(incubator.RELATE_DONE, params);
}

export async function queryRelateNon(params) {
  return http.get(incubator.RELATE_NON, params);
}

export async function queryFinancePayable(params) {
  return http.get(incubator.FINANCE_PAYABLE, params);
}

export async function querySaveRelate(params) {
  return http.post(incubator.RELATE_SAVE, params);
}

export async function queryCancelRelate(params) {
  return http.get(incubator.RELATE_CANCEL, params);
}

export async function queryExportFinanceRecord(params) {
  http.download(
    incubator.FINANCE_EXPORT,
    params,
    `资金流水明细导出${moment().format('yyyyMMddHHmmss')}.xlsx`,
  );
}



// WEBPACK FOOTER //
// ./src/api/incubator/finance.js